module.exports = __webpack_public_path__ + "static/media/sugata_chanda.26952b00.jpeg";